<template>
  <div
    v-if="flag"
    class="comp-loadstate"
  >
    <slot name="entire">
      <div class="loadstate-inner">
        <!-- <iconfont class="state-icon" :name="load.iconname"> </iconfont> -->
        <img
          v-if="flag === 1"
          style="width:273px;height: 308px"
          src="./loadstatus/2ing.png"
          alt=""
        >
        <!-- <img
                    v-if="flag===2"
                    style="width:250px;height: 253px"
                    src="~./loadstatus/2-nothing.png"
                    alt=""> -->
        <img
          v-if="flag === 3"
          style="width:250px;height: 253px"
          src="./loadstatus/2-nothing.png"
          alt=""
        >
        <img
          v-if="flag === 4"
          style="width:248px;height: 254px"
          src="./loadstatus/2-server-err.png"
          alt=""
        >
        <img
          v-if="flag === 5"
          style="width:315px;height: 177px"
          src="./loadstatus/2-404.png"
          alt=""
        >
        <img
          v-if="flag === 6"
          style="width:315px;height: 177px"
          src="./loadstatus/2-404.png"
          alt=""
        >
        <img
          v-if="flag === 7"
          style="width:315px;height: 177px;margin-top: 200px;"
          src="./loadstatus/2-404.png"
          alt=""
        >
        <p class="state-txt">
          {{ loadTxt || load.txt }}
        </p>
        <!-- <p class="sub-state-txt" v-if="subLoadTxt || load.subTxt">{{ subLoadTxt || load.subTxt }}</p> -->
        <slot> </slot>
      </div>
    </slot>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'LoadState',
  components: {
    // benchBtn: () => import("~/components/workbench/benchBtn.vue"),
  },
  props: {
    /**loadFlag
     * 0: 隐藏加载组件
     * 1: 加载中
     * 2：无更多数据
     * 3: 暂无数据
     * 4: 服务器开小差
     * 5：页面不存在
     * 6：没有找到模板
     * 7: 搜索不到数据
     */
    loadFlag: {
      type: [Number, String],
      default: 1,
      required: true
    },
    // 自定义提示文案
    loadTxt: {
      type: String,
      default: ''
    },
    // 自定义提示文案
    subLoadTxt: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    flag() {
      return Number(this.loadFlag)
    },
    load() {
      /* eslint-disable */
      // eslint-disable-next-line
      let iconname = '',
        txt = '',
        subTxt = ''
      switch (this.flag) {
        case 1:
          iconname = '#icon-notdata'
          txt = '加载中...'
          break
        case 2:
          iconname = '#icon-notdata'
          txt = '没有更多内容了~'
          break
        case 3:
          iconname = '#icon-notdata'
          txt = '这里什么都没有哦'
          break
        case 4:
          iconname = '#icon-notdata'
          txt = '服务器开小差'
          break
        case 5:
          iconname = '#icon-notdata'
          txt = '页面不存在'
          break
        case 6:
          iconname = '#icon-notdata'
          txt = '没有找到模板'
          break
        case 7:
          iconname = '#icon-notdata'
          txt = '搜索为空'
          subTxt = '欢迎将需求反馈给我们，若需求描述清晰准确，我们将尽快补充更新'
          break
        default:
          iconname = '#icon-notdata'
          txt = '加载中...'
          break
      }
      return { iconname, txt }
    }
  },
  async mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.comp-loadstate,
.loadstate-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.comp-loadstate {
  min-height: 100px;
}
.loadstate-inner {
  flex-direction: column;
}
.state-icon {
  width: 167px;
  height: 116px;
}
.state-txt {
  margin-top: 35px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.no-reult-btn {
  margin-top: 33px;
}
</style>
